import { useEffect } from "react";
import { useMap } from "react-leaflet";

/**
 * #1394 (D221 G4, D354): the new look's maps give the Street / Satellite switch 44px tap boxes. Leaflet
 * builds that control itself, so the rules are in index.css (`.nw-basemap-tap`) and this marks the map
 * they apply to. Mounted by `Basemaps tapBox` only; the shipped maps never mount it and keep leaflet's
 * own control (D217).
 */
export default function BasemapTapBox() {
  const map = useMap();
  useEffect(() => {
    const el = map.getContainer();
    el.classList.add("nw-basemap-tap");
    return () => el.classList.remove("nw-basemap-tap");
  }, [map]);
  return null;
}
